import React, { Component, Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import '../../asset/css/custom.css';

export class PageTop extends Component {
  render() {
    return (
       <Fragment>
        
              <Container fluid={true} className='PageTop p-0'>
                 <div className='toppageOverlay'>
                      <Container className='toppageContent'>
                          <Row>
                              <Col className="text-center">
                        
                              <h4 className='toppageSubTitle'>{this.props.pageTitle}</h4>
                              
                         </Col>
                          </Row>
                      </Container>
      
      
                  </div>
              </Container>
      
           </Fragment>
    )
  }
}

export default PageTop
